import React, { useEffect, useState } from "react";
import Routes from "./components/Routes";
import { MovePlannerProvider } from "./context/move_planner/movePlanner";
import { useDispatch } from "react-redux";
import { useMoveInfoForm, usePropertyInfoForm, useStorageMoveInfoForm } from "./functions/estimateFormFn";
import { thunkLoadLoginFromSession } from "./redux/reducers/user_info/userInfoReducer";
import AppLoading from "./components/skeleton/loading/AppLoading";
import { loadProgress } from "./redux/reducers/progress/progressReducer";
import { loadProgress as storageLoadProgress } from "./redux/reducers/storage_progress/progressReducer";

const App = () => {
  const dispatch = useDispatch();
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("userSessionData")) {
      const userSessionData = JSON.parse(sessionStorage.getItem("userSessionData"));
      if (userSessionData["loggedIn"] === true) {
        const userInfoSession = {
          loggedIn: true,
          email: userSessionData["email"],
          customerName: userSessionData["customerName"],
          isEmailVerified: userSessionData["isEmailVerified"],
          isPhoneVerified: userSessionData["isPhoneVerified"],
          userId: userSessionData["userId"],
          phone: userSessionData["phone"],
          alternatePhone: userSessionData["alternatePhone"],
        };
        dispatch(thunkLoadLoginFromSession(userInfoSession));
      }
    }
    if (sessionStorage.getItem("progressData") !== null) {
      const progressData = JSON.parse(sessionStorage.getItem("progressData"));
      const state = {
        step1: progressData["step1"],
        step2: progressData["step2"],
        step3: progressData["step3"],
        step4: progressData["step4"],
      };
      const payload = { state: state };
      dispatch(loadProgress(payload));
    }
    if (sessionStorage.getItem("storageProgressData") !== null) {
      const progressData = JSON.parse(
        sessionStorage.getItem("storageProgressData")
      );
      const state = {
        step1: progressData["step1"],
        step2: progressData["step2"],
        step3: progressData["step3"],
      };
      const payload = { state: state };
      dispatch(storageLoadProgress(payload));
    }
    setHasLoaded(true);
  }, [dispatch]);

  const estimateForm = {
    useMoveInfoForm: useMoveInfoForm(),
    usePropertyInfoForm: usePropertyInfoForm(),
    useStorageMoveInfoForm: useStorageMoveInfoForm()
  };

  if (hasLoaded === false) {
    return <AppLoading />;
  }

  return (
    <>
      <MovePlannerProvider value={{ estimateForm: estimateForm }}>
        <Routes />
      </MovePlannerProvider>
    </>
  );
}

export default App;